import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './error.module.scss'
import PrimaryButton from '../buttons/PrimaryButton';
import PaymentAccountConfirmationErrorScreenTypeEnum from '../../types/enums/errorScreenTypeEnum'
import FeatherIcon from "feather-icons-react";


interface IProps {
    customerName: string;
    errorType: PaymentAccountConfirmationErrorScreenTypeEnum;
    finishConnection: () => void,
}

const PaymentAccoutConfirmationError: React.FC<IProps> = ({ customerName, errorType, finishConnection }: IProps) => {
    const { t } = useTranslation();

    const bankSharedMessage = t<string>('Your bank data has been shared with {{customerName}}, ', { customerName });
    let icon = "alert-triangle";
    let message = bankSharedMessage + t<string>('but we are unable to confirm your account for payment at this time.');

    if (errorType === PaymentAccountConfirmationErrorScreenTypeEnum.PaymentAccountConfirmationCancelledError) {
        icon = "x"
        message = bankSharedMessage + t<string>('but you have not selected an account for payment.');
    }

    return (
        <div className={styles.screen} data-testid='error-container'>
            <div className={styles.topWrapper}>
                <FeatherIcon icon={icon} className={styles.icon} />
                <h1>{t<string>('Payment account selection cancelled')}</h1>
                <div className={styles.content}>
                    <p>{message}</p>
                    <p>{t<string>('You may be asked to provide more information at a later time.')}</p>
                </div>
            </div>
            <div className={styles.buttonWrapper}>
                <PrimaryButton onClick={finishConnection}>{t<string>('Return to {{customerName}}', { customerName })}</PrimaryButton>
            </div>
        </div>
    );
}
export default PaymentAccoutConfirmationError;
